/**
 * @module app.hl7
 * @preferred
 */

import { autoinject } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { AppModule, MemberFilters } from 'app/shared/config/modules';

@autoinject()
export class HealthLevel7ManagementModule extends AppModule {

    public readonly code = 'hl7';
    public readonly memberFilters = [];

    constructor(private readonly logger: AppLogger, memberFilters: MemberFilters) {
        super();

        logger.source = this;

        memberFilters.registerFilters(this.memberFilters);
    }

    public getTranslationNamespaces(): ReadonlyArray<string> {
        return ['hl7'];
    }
}
